var map = {
	"./featured-item/coach@3x.png": 168,
	"./featured-item/cuff@3x.png": 172,
	"./featured-item/fastclix_lancets@3x.png": 176,
	"./featured-item/fastclix_lancing_kit@3x.png": 180,
	"./featured-item/guide@3x.png": 184,
	"./featured-item/guide_me@3x.png": 188,
	"./featured-item/mysugr_coach_voucher_based_1@3x.png": 192,
	"./featured-item/pro@3x.png": 196,
	"./featured-item/scale@3x.png": 200,
	"./featured-item/softclix_lancets@3x.png": 204,
	"./featured-item/softclix_lancing_kit@3x.png": 208,
	"./featured-item/strips_subscription_guide@3x.png": 212,
	"./item/coach@3x.png": 268,
	"./item/cuff@3x.png": 270,
	"./item/fastclix_lancets@3x.png": 272,
	"./item/fastclix_lancing_kit@3x.png": 274,
	"./item/guide@3x.png": 276,
	"./item/guide_me@3x.png": 278,
	"./item/guide_strips@3x.png": 280,
	"./item/mysugr_coach_voucher_based_1@3x.png": 282,
	"./item/pro@3x.png": 284,
	"./item/scale@3x.png": 286,
	"./item/softclix_lancets@3x.png": 288,
	"./item/softclix_lancing_kit@3x.png": 290,
	"./item/strips_subscription_guide@3x.png": 292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;